import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Clock, AlertTriangle } from 'lucide-react';

interface SessionTimeoutModalProps {
  isOpen: boolean;
  remainingSeconds: number;
  onExtend: () => void;
  onLogout: () => void;
}

export const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({
  isOpen,
  remainingSeconds,
  onExtend,
  onLogout,
}) => {
  if (!isOpen) return null;

  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
      <Card className="w-full max-w-md mx-4 shadow-2xl">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-orange-100 p-4 rounded-full">
              <AlertTriangle className="w-12 h-12 text-orange-600" />
            </div>
          </div>
          <CardTitle className="text-2xl">세션 만료 경고</CardTitle>
          <CardDescription>
            세션이 곧 만료됩니다
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert className="bg-orange-50 border-orange-200">
            <Clock className="w-4 h-4 text-orange-600" />
            <AlertDescription className="text-orange-800">
              <div className="flex items-center justify-between">
                <span>남은 시간</span>
                <span className="text-2xl font-bold tabular-nums">
                  {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
                </span>
              </div>
            </AlertDescription>
          </Alert>

          <div className="text-sm text-gray-600 text-center">
            비활동 상태가 지속되면 자동으로 로그아웃됩니다.
            <br />
            계속 작업하시려면 "세션 연장" 버튼을 클릭하세요.
          </div>

          <div className="grid grid-cols-2 gap-3 pt-2">
            <Button
              variant="outline"
              onClick={onLogout}
              className="w-full"
            >
              로그아웃
            </Button>
            <Button
              onClick={onExtend}
              className="w-full bg-primary hover:bg-primary/90"
            >
              세션 연장
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
